import { gsap } from "gsap/all";

/* Accordion */
export function createAccordion(stage) {
  let Accordion = document.querySelectorAll(".accordion-container");
  var ease = "power4.inOut";
  if (stage == "potfolio") {
    let Triggers = [],
      Wrappers = [],
      Contents = [];
    let animation, close;

    if (Accordion.length > 0) {
      for (let i = 0; i < Accordion.length; i++) {
        Wrappers[i] = Accordion[i].querySelectorAll(".listItem");
        Triggers[i] = Accordion[i].querySelectorAll(".listTrigger");
        Contents[i] = Accordion[i].querySelectorAll(".listContent");

        if (Triggers[i].length > 0) {
          for (let j = 0; j < Triggers[i].length; j++) {
            _clickEvent(Triggers[i][j], i, j);
          }
        }
        if (Contents[i].length > 0) {
          for (let j = 0; j < Contents[i].length; j++) {
            if (!Contents[i][j].classList.contains("accordion--active")) {
              Contents[i][j].style.height = 0;
            }
          }
        }
      }

      animation = function (el, type) {
        if (type == "open") {
          el.classList.add("accordion--active");

          el.style.height = "auto";
          let height = el.clientHeight;
          el.style.height = 0;

          new gsap.timeline({
            onComplete: () => {
              el.style.height = "auto";
            },
            onStart: () => {
              el.parentNode.classList.add("live");
            },
          }).fromTo(
            el,
            {
              ease: ease,
              duration: 0.7,
              height: 0,
            },
            { ease: ease, height: height, duration: 1 }
          );
        } else {
          new gsap.timeline({
            onComplete: () => {
              el.classList.remove("accordion--active");
            },
            onStart: () => {
              el.parentNode.classList.remove("live");
            },
          }).to(el, { ease: ease, duration: 0.7, height: 0 });
        }
      };
      close = function (i) {
        let triggerActive = Accordion[i].querySelector(".accordion--active");
        if (triggerActive) {
          triggerActive.classList.remove("accordion--active");
        }
        let contentActive = Accordion[i].querySelector(".accordion--active");
        if (contentActive) {
          contentActive.classList.remove("accordion--active");
          animation(contentActive, "close");
        }
      };

      function _clickEvent(el, i, index) {
        el.addEventListener("click", function (e) {
          // console.log(e)
          e.preventDefault();

          //e.target クリックした要素
          if (Contents[i][index]) {
            if (!Contents[i][index].classList.contains("accordion--active")) {
              close(i);
              e.target.classList.add("accordion--active");
              animation(Contents[i][index], "open");
            } else {
              close(i);
            }
          }
        });
      }
    }
  }
}
/* ************************************************ */
